export const formatDateTime = (timestamp: string | number | Date) => {
    const date = new Date(timestamp)
    let hours = date.getHours()
    let minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
    const yyyy = date.getFullYear();
    const month = date.getMonth() + 1;// Months start at 0!
    const mm = month < 10 ? '0' + month : month;
    const dd = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();

    hours = hours % 12
    hours = hours ? hours : 12
    return dd + '/' + mm + '/' + yyyy + ' - ' + hours + ':' + minutes
}